var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelectPraise = function SvgSelectPraise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 2.81247L9.18765 9.18762",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43723 2.81261L2.81242 2.81261",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81264 8.43726L2.81264 2.81245",
    stroke: "#FFAA33",
    strokeWidth: 1.87494,
    strokeLinecap: "round"
  }))));
};
export default SvgSelectPraise;